import React from "react";

/**
 * @return {string}
 */
export function CheckEmptyFieldQuiz(items) {
    for(let i = 0; i < items.length; i++ ) {
        if(items[i].question === ''){
            return 'English fields cannot be left blank'
        } else if(items[i].answer === ''){
            return 'Samoan fields cannot be left blank'
        }
    }
    return '';
}
